(() => {
  const inited = new WeakSet();

  function setup(carousel) {
    if (inited.has(carousel)) return;
    inited.add(carousel);

    const id = carousel.getAttribute('data-gv-carousel');
    const track = carousel.querySelector('.gv-carousel__track');
    if (!track) return;

    const prev = document.querySelector(`[data-gv-carousel-prev="${id}"]`);
    const next = document.querySelector(`[data-gv-carousel-next="${id}"]`);

    function slideWidth() {
      const slide = track.querySelector('.gv-carousel__slide');
      if (!slide) return track.clientWidth;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function go(dir) {
      track.scrollBy({ left: dir * slideWidth() * Math.max(1, Math.floor(track.clientWidth / slideWidth())), behavior: 'smooth' });
    }

    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => updateButtons(), { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-gv-carousel]').forEach(setup);
})();
